export enum PaymentRequestStatus {
  Open = 'Open',
  Closed = 'Closed',
}